
import { useQuery } from '@tanstack/react-query';
import { getServices } from '@/services/serviceService';
import { Service } from '@/lib/data';

export function useServices() {
  return useQuery<Service[], Error>({
    queryKey: ['services'],
    queryFn: getServices,
  });
}
